var T = {
    'Next': {
        'pl': 'Dalej',
    },
    'Book': {
        'pl': 'Zarezerwuj',
    }
}

export default T;